<div class="textRecordsContainer">
   
    <div class="header hdr">
         <div class="row" id="emailTableSearch">
                <div class="col-3">
        <h5><span class="animateH5">Obligation</span></h5>
        </div>
        <div class="col px-0">
       </div>
    </div>
    </div>
     <div class="container-fluid">
     </div>
</div>        